/**
 * Converts a price string (euros) to cents, rounded to 2 decimal places
 */
export const convertPriceToCents = (price: string): number => Number((Number(price) * 100).toFixed(2))
